export default __webpack_public_path__ + "static/SofiaProMedium-a97b1376c9174d8dae9524bb69f79f9c.woff";